import React from 'react';
import { OTHER_ORGS } from '../../constants/abdmCopy';

/**
 * ConsentStatusChip — displays a consent's status. DISPLAY ONLY.
 *
 * Renders the backend's `displayStatus` (REQUESTED|GRANTED|DENIED|REVOKED|EXPIRED|SUBMIT_FAILED),
 * the single derived status. Never recompute it from status/abdmStatus. Gating logic (e.g.
 * "Request records") must use the domain `status`, never this component.
 *
 * Props:
 *   displayStatus {string} — required
 *   isDark        {boolean} — required
 */
const STATUS_META = {
  REQUESTED: { label: 'Requested', bg: '#e0f2fe', dark: '#0c4a6e', text: '#0369a1', darkText: '#bae6fd' },
  GRANTED:   { label: 'Granted',   bg: '#dcfce7', dark: '#14532d', text: '#166534', darkText: '#bbf7d0' },
  REVOKED:   { label: 'Revoked',   bg: '#fee2e2', dark: '#7f1d1d', text: '#991b1b', darkText: '#fca5a5' },
  DENIED:    { label: 'Denied',    bg: '#fee2e2', dark: '#7f1d1d', text: '#991b1b', darkText: '#fca5a5' },
  EXPIRED:   { label: 'Expired',   bg: '#f3f4f6', dark: '#1f2937', text: '#4b5563', darkText: '#9ca3af' },
  // Domain status collapses this to REVOKED (never reached ABDM, nothing to purge) —
  // abdm_status="SUBMIT_FAILED" keeps it visually distinct from a real revoke/deny.
  SUBMIT_FAILED: { label: OTHER_ORGS.notSent, bg: '#fef3c7', dark: '#78350f', text: '#92400e', darkText: '#fde68a' },
};

export default function ConsentStatusChip({ displayStatus, isDark }) {
  const meta = STATUS_META[displayStatus] ?? STATUS_META.REQUESTED;
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 99,
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: '0.03em',
      background: isDark ? meta.dark : meta.bg,
      color: isDark ? meta.darkText : meta.text,
    }}>
      {meta.label}
    </span>
  );
}
